import LoginFormModal from "../component/LoginFormModal";

import { Helmet } from "react-helmet";
import ErrorBoundaryWrap from "../error-boundries/ErrorBoundaryWrap";

import MarqueeHome from "../component/Marquee";

import HeroBanner from "../component/HeroBanner";

import { useEffect, useState } from "react";
import AxiosClient from "../client/AxiosClient";
import { API_HOME_META } from "../ApiEndPoints";
import CoursesGrid1 from "../sections/CoursesGrid1";
import RegisterationFormModal from "../component/RegistrationFormModal";
import HeroBanner3 from "../component/HeroBanner3";

export default function RegisterPage() {
  return (
    <main>
      <HomeMeta />
      <ErrorBoundaryWrap component={HeroBanner3} />
      <ErrorBoundaryWrap component={MarqueeHome} />
      <ErrorBoundaryWrap component={CoursesGrid1} />
      <ErrorBoundaryWrap component={RegisterationFormModal} />
    </main>
  );
}

function HomeMeta() {
  const [homeMeta, setHomeMeta] = useState(null);

  useEffect(() => {
    AxiosClient.get(`${API_HOME_META}`)
      .then((response) => {
        const data = response.data.data;

        setHomeMeta(data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  }, []);

  return (
    <Helmet>
      <title>{homeMeta?.meta_title || "IALM"}</title>

      <meta name="keywords" content={homeMeta?.meta_keywords} />
      <meta name="description" content={homeMeta?.meta_description} />
    </Helmet>
  );
}
